// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disclaimerText{color:#666}.login-form{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);max-width:100%;max-height:100%;min-width:400px;min-height:500px;padding:80px 40px;box-sizing:border-box;background:hsla(0,0%,100%,.4)}.avatar{position:absolute;width:80px;height:80px;border-radius:50%;overflow:hidden;top:-40px;left:calc(50% - 40px)}.login-form h2{margin:0;padding:0 0 20px;color:#fff;text-align:center;text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
